import { useMemo } from 'react'
import { SelectOption } from '../../../containers/BulkSheetView/components/cellEditor/MultiSelectCellEditor'
import { PermissionPolicyOption } from '../../../../domain/value-object/PermissionPolicy'
import { useAvailableFunctionsTooltipGetter } from './availableFunctionsTooltip'

export const useAttachablePermissionPolicyOptions = (
  permissionPolicyOptions: PermissionPolicyOption[]
) => {
  const { getAvailableFunctionsTooltipOfPermissionPolicy } =
    useAvailableFunctionsTooltipGetter()
  const attachablePermissionPolicyOptions: SelectOption[] = useMemo(
    () =>
      permissionPolicyOptions
        .filter(p => p.attachable)
        .map(p => ({
          value: p.uuid,
          label: p.name,
          tooltip: getAvailableFunctionsTooltipOfPermissionPolicy(p),
          disabled: p.attachedByDefault || !p.attachable,
        })),
    [permissionPolicyOptions, getAvailableFunctionsTooltipOfPermissionPolicy]
  )

  return attachablePermissionPolicyOptions
}
